module.exports = __webpack_public_path__ + "img/vipbanner.2adab1ed.png";